import React, { useEffect, useState } from "react";
import Admin from "../index";
import { createUserValidations } from "../../../Validations/Validations";
import HomeIcon from "@mui/icons-material/Home";
import functions from "../../../utils/Api";
import { useNavigate } from "react-router-dom";
import { dispatchRefreshApiCallUser } from "../../../Redux/dispatcher";
import { useDispatch, useSelector } from "react-redux";
import DiscardChangesDialog from "../../../components/DiscardChangesDialog/DiscardChangesDialog";
import { Box } from "@mui/material";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import Toaster from "../../../components/Toaster/Toaster";
import CustomBreadcrumbs from "../../../components/CustomBreadcrumbs";
import { setToasterStatusMsg } from "../../../Redux/reportSlice";

const CreateUser = () => {
  const navigate = useNavigate();
  const dispatcher = useDispatch();
  // let userFormValidations = createUserValidations();
  const userType = useSelector((state) => state.persistApiData.userType);
  const [userDetailsChanges, setUserDetailsChanges] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [userDetails, setUserDetails] = useState({
    // userType: "",
    location: null,
    officeLocationId: null,
    firstName: "",
    lastName: "",
    employeeId: "",
    email: "",
    password: "",
    contactNumber: null,
    designation: "",
    permission: [],
    roleId: userType,
    isActive: true,
  });

  const breadCrumbData = [
    {
      label: "Home",
      path: "/cms/dashboard",
    },
  ];

  const handleRedirect = () => {
    const keysToCheck = Object.keys(userDetails).filter(
      (key) => key !== "roleId"
    );
    const hasLengthGreaterThanOne = keysToCheck.some((key) => {
      const value = userDetails[key];
      return (
        (typeof value === "string" && value.length > 0) || // String with length > 1
        (Array.isArray(value) && value.length > 0) ||
        (typeof value === "number" && value !== null)
      );
    });
    if (hasLengthGreaterThanOne) {
      setUserDetailsChanges(hasLengthGreaterThanOne);
    } else {
      setUserDetailsChanges(false);
      navigate("/cms/users-list");
    }
  };

  const handleCreate = () => {
    setUserDetailsChanges(false);
    navigate("/cms/users-list");
  };

  let handleDiscardDialogClose = (status) => {
    setUserDetailsChanges(status);
  };

  const handleSubmitUser = () => {
    setDisableBtn(true);
    try {
      functions
        .post("/employee", userDetails)
        .then((res) => {
          if (res) {
            setDisableBtn(false);
            dispatcher(dispatchRefreshApiCallUser(true));
            dispatcher(
              setToasterStatusMsg({
                msg: "User Created successfully",
                severity: "success",
              })
            );
            navigate("/cms/users-list");
          }
        })
        .catch((err) => {
          console.log("error:90", err);
          setDisableBtn(false);
          dispatcher(
            setToasterStatusMsg({
              msg: err,
              severity: "error",
            })
          );
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Box className="Admin-breadCrumb">
        <CustomBreadcrumbs items={breadCrumbData} currentLabel="Users" />
      </Box>
      <Admin
        title="Add"
        userDetails={userDetails}
        setUserDetails={setUserDetails}
        handleSubmitUser={handleSubmitUser}
        handleRedirect={handleRedirect}
        // userFormValidations={createUserValidations()}
        disableBtn={disableBtn}
      />
      {userDetailsChanges && (
        <DiscardChangesDialog
          title="Unsaved Changes"
          text=" If you go back now, any information you've entered will be lost.
              Are you sure you want to leave without saving?"
          createBtn=" Yes, Go Back"
          open={userDetailsChanges}
          handleCreate={handleCreate}
          handleClose={handleDiscardDialogClose}
        />
      )}
    </div>
  );
};

export default CreateUser;
